import { h, reactive, renderSlot } from 'vue'
import './style.scss'

const AChip = {
    name: 'AChip',
    props: {
        removable: {
            type: Boolean,
            default: false,
        },
    },
    setup: (props, ctx) => {

        const state = reactive({
            
        })

        const renderView = () =>
            h('div', {
                class: ['a-chip'],
            }, h('div', {
                class: ['a-chip__inner'],
            }, [
                h('span', {
                    class: ['a-chip__value']
                }, renderSlot(ctx.slots, 'default')),
                props.removable ? 
                    h('button', {
                        type: 'button',
                        class: ['a-chip__remove'],
                        onClick: $e => ctx.emit('remove', $e) 
                    }, h('svg', {
                        width: 12,
                        height: 12,
                        xmlns: 'http://www.w3.org/2000/svg',
                        viewBox: '0 0 24 24',
                    }, [
                        h('path', {
                            d: 'M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z',
                        })
                    ])) : ''
            ]))

        return {
            renderView
        }
    },
    render() {
        return this.renderView()
    },
}

export { AChip }
